import React, { useState, useEffect, useRef } from "react";
import FilterToolDDL from "../../components/Filter/FilterToolDDL";
import { Modal } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import {
  calendar,
  CancelSyncReply,
  ClearFilter,
  DateTimeArrow,
  DeleteIcon,
  FilterIcon,
  ForwardWhite,
  InfoIcon1,
  PauseWhite,
  PlayBlue,
  PlayWhite,
  RecordingReply,
  RemoveIcon,
  SaveFilter,
  SearchIcon,
  SearchIconWhite,
  SingleRecording,
  SyncReply,
  ViewMosaic,
  WarningDelete,
} from "../../assets/images";
import {
  addMinutesToDate,
  ConvertDate,
  formatJSDateInDDMMYYYY,
  formatJSDateObject,
  frontDateConverter,
  getCSIds,
  parseSCSEntitiesToObect,
  stringifyObjToSCSEntities,
} from "../../utils/utils";
import Playback from "../../components/Playback/Playback";
import { getInfoList } from "../../services/alertGridServices";
import { useDispatch, useSelector } from "react-redux";
import { filterActions } from "../../redux/features/shared/filter";
import { buttonActions } from "../../redux/features/shared/button";
import { modalActions } from "../../redux/features/shared/modal";
import { RecordingList } from "./RecordingList";
import AlertTemplateMessage from "../Configuration/AlertTemplate/AlertTemplateMessage";
import { ErrorToast } from "../../CustomHooks/ErrorToast";
import RecordingView from "./RecordingView";
import WebRTCPlayer from "../Cameras/WebRTCPlayer";
import SkelSinglePlayback from "../Cameras/SkelSinglePlayback";
import { SeekBar } from "./SeekBar";
import { recordingActions } from "../../redux/features/recording/recording";
import {
  fetchClientList,
  fetchInterfaceList,
  fetchInterfaceSubTypeList,
  fetchSavedFiltersList,
  fetchSiteList,
} from "../../services/filterService";
import {
  fetchCameraDetailsById,
  fetchCameraDetailsByIdWD,
  fetchDevicesList,
  fetchRecordingCameraDetailsById,
  fetchRecordingDevicesList,
} from "../../services/camera/cameraService";
import { playbackActions } from "../../redux/features/shared/playback";
import { RecordingVideo } from "./RecordingVideo";
import MultiplaybackView from "../CameraNewUI/MultiplaybackView";
import { CircularProgress } from "@mui/material";
import { WarningToast } from "../../CustomHooks/WarningToast";

const CLEARSELECTION = "Clear Selection";
const SELECTALL = "Select ALL";
const RECORDING = "Centralized Recording";

const CUSTOMER = "Customer";
const SITE = "Site";
const INTERFACESUBTYPE = "Interface Sub Type";
const INTERFACE = "Interface Name";
const SAVEDFILTER = "Saved Filter";

export const CentralizeRecording = React.memo(({ isDarkTheme }) => {
  const [startDateString, setStartDateString] = useState("");
  const [endDateString, setEndDateString] = useState("");
  const [startMode, setStartMode] = useState(true);
  const [popOpen, setPopOpen] = useState(false);
  const [isMultiPlay, setIsMultiPlay] = useState(false);
  const [loading, setLoading] = useState(false);

  const [value, setValue] = useState(0); // Initial value at 50%

  const handleSeekBarChange = (event) => {
    setValue(event.target.value);
  };
  //#region redux state and dispatcher function
  const dispatch = useDispatch();

  const filter = useSelector((state) => state?.filter);
  const {
    savedFilters,
    customer,
    site,
    interfaceSubType,
    interface: deviceInterface,
    filterName,
  } = filter;

  const buttonVisibilityState = useSelector(
    (state) => state?.button?.buttonVisibilityState
  );

  const {
    visibleFilterBtn,
    visibleClearFilterBtn,
    visibleSaveFilterBtn,
    visibleSyncReplayBtn,
    visibleClearSyncReplayBtn,
    visibleViewMosaicBtn,
    visibleSingleViewBtn,
  } = buttonVisibilityState;

  const devicesList = useSelector(
    (state) => state?.recording?.recording?.devicesList
  );

  const cameraDetails = useSelector(
    (state) => state?.recording?.recording?.cameraDetails
  );

  const deviceListSearchText = useSelector(
    (state) => state?.recording?.recording?.deviceListSearchText
  );

  const modalState = useSelector(
    (state) => state?.recording?.recording?.modalState
  );
  // const { showInfoFilterModal } = modalState;

  const modalVisibilityState = useSelector(
    (state) => state?.modal?.modalVisibilityState
  );
  const { showSavedFilterSaveModal, showSavedFilterDeleteModal } =
    modalVisibilityState;

  const filterInfoName = useSelector(
    (state) => state?.recording?.recording?.filterInfoName
  );

  const cameraPlaybackList = useSelector(
    (state) => state?.recording?.recording?.cameraPlaybackList
  );

  const visibleMultiPlaybackView = useSelector(
    (state) => state?.recording?.recording?.visibleMultiPlaybackView
  );

  const playbackComponentStates = useSelector((state) => state?.playback);
  const {
    startDate,
    endDate,
    selectedStartDate,
    selectedEndDate,
    defaultEndDate,
  } = playbackComponentStates;

  // Reset all states when component unmounts
  useEffect(() => {
    return () => {
      dispatch(filterActions.resetFilterStates());
      dispatch(buttonActions.resetAllButtons());
      dispatch(recordingActions.resetRecordingStates());
    };
  }, []);

  useEffect(() => {
    dispatch(fetchSavedFiltersList(RECORDING));
    dispatch(fetchClientList());
  }, []);

  useEffect(() => {
    if (isNotNullOrEmpty(devicesList) && visibleClearSyncReplayBtn) {
      dispatch(buttonActions.disableSyncReplayBtn(false));
    }
  }, [devicesList]);

  // Disable sync replay & clear sync replay buttons
  useEffect(() => {
    if (
      !isNotNullOrEmpty(devicesList) &&
      !isNotNullOrEmpty(savedFilters?.selected) &&
      isNotNullOrEmpty(customer?.selected)
    ) {
      dispatch(buttonActions.disableSyncReplayBtn(true));
      dispatch(buttonActions.disableClearSyncReplayBtn(true));
    }
  }, [devicesList]);

  useEffect(() => {
    // Enable or disable view mosaic button
    // if (isViewMosaicBtnEnabled) {
    //   dispatch(buttonActions.disableViewMosaicBtn(false));
    // } else {
    //   dispatch(buttonActions.disableViewMosaicBtn(true));
    // }

    // Enable or disable save filter button
    if (isSaveFilterBtnEnabled()) {
      dispatch(buttonActions.disableSaveFilterBtn(false));
    } else {
      dispatch(buttonActions.disableSaveFilterBtn(true));
    }
  }, [savedFilters?.selected, customer?.selected, devicesList]);

  useEffect(() => {
    // true is disabled, false is enabled
    // Reset all filter buttons
    if (
      !isNotNullOrEmpty(savedFilters?.selected) &&
      !isNotNullOrEmpty(customer?.selected)
    ) {
      dispatch(buttonActions.resetAllButtons());
    }

    // Enable or disable sync reply mode
    if (isNotNullOrEmpty(devicesList)) {
      dispatch(buttonActions.disableSyncReplayBtn(false));
    } else {
      dispatch(buttonActions.disableSyncReplayBtn(true));
    }

    // Enable or disable filter & clear filter buttons
    if (shouldFilterAndClearFilterBtnsBeEnabled()) {
      dispatch(buttonActions.disableFilterBtn(false));
      dispatch(buttonActions.disableClearFilterBtn(false));
    } else {
      dispatch(buttonActions.disableFilterBtn(true));
      dispatch(buttonActions.disableClearFilterBtn(true));
    }

    // Fetch saved filters list
    if (!isNotNullOrEmpty(savedFilters?.options)) {
      dispatch(fetchSavedFiltersList(RECORDING));
    }

    // Fetch customer DDL data
    if (!isNotNullOrEmpty(customer?.options)) {
      dispatch(fetchClientList());
    }

    // Fetch site DDL data
    if (isNotNullOrEmpty(customer?.selected)) {
      let ids = getCSIds(customer?.selected);
      dispatch(fetchSiteList(ids ?? ""));
    }
    if (!isNotNullOrEmpty(customer?.selected)) {
      dispatch(filterActions.resetSite());
      dispatch(filterActions.resetInterfaceSubType());
      dispatch(filterActions.resetInterface());
      dispatch(recordingActions.resetDevicesList());
    }

    if (!isNotNullOrEmpty(site?.selected)) {
      dispatch(filterActions.resetInterfaceSubType());
      dispatch(filterActions.resetInterface());
    }

    // fetch interfacesubtype DDL data
    if (isNotNullOrEmpty(site?.selected)) {
      let siteIds = getCSIds(site?.selected);
      dispatch(fetchInterfaceSubTypeList(siteIds ?? ""));
    }
    if (isNotNullOrEmpty(interfaceSubType?.selected)) {
      let siteIds = getCSIds(site?.selected);
      let interfaceSubTypeIds = getCSIds(interfaceSubType?.selected);
      dispatch(fetchInterfaceList(interfaceSubTypeIds ?? "", siteIds ?? ""));
    }
    if (!isNotNullOrEmpty(interfaceSubType?.selected)) {
      dispatch(filterActions.resetInterface());
    }
  }, [
    customer?.selected,
    site?.selected,
    interfaceSubType?.selected,
    deviceInterface?.selected,
    savedFilters?.selected,
  ]);

  //Check if an object or array is not null or empty
  //Returns true if finds null or empty object, false otherwise
  const isNotNullOrEmpty = (obj) => {
    return (
      obj !== null &&
      typeof obj === "object" &&
      (Array.isArray(obj) ? obj.length > 0 : Object.keys(obj).length > 0)
    );
  };

  const handleClearSavedFilterClick = () => {};

  const handleFilterItemChange = (value, filter) => {
    // dispatch(recordingActions.resetCameraPlaybackList());
    // dispatch(recordingActions.resetPlaybackState());

    switch (filter) {
      case CUSTOMER:
        dispatch(filterActions?.setCustomerSelected(value));
        dispatch(filterActions.resetSavedFilter());
        dispatch(recordingActions.resetDevicesList());
        break;
      case SITE:
        dispatch(filterActions?.setSiteSelected(value));
        break;
      case INTERFACESUBTYPE:
        dispatch(filterActions.setInterfaceSubTypeSelected(value));
        break;
      case INTERFACE:
        dispatch(filterActions?.setInterfaceSelected(value));
        break;
      default:
        break;
    }
  };

  const filterToolDDLProps = {
    visibleDDLSingleSelect: false,
    visibleDDLMultiSelect: true,

    DDLSingleSelectProps: {
      labelledBy:
        savedFilters?.selected?.filterName !== undefined
          ? `${SAVEDFILTER}: ` + savedFilters?.selected?.filterName
          : `${SAVEDFILTER}`,
      selected: isNotNullOrEmpty(savedFilters?.selected)
        ? savedFilters?.selected
        : null,
      emptyOptionLabel: "No Saved Filters",
      handleClearSelectedClick: handleClearSavedFilterClick,
      clearDisabled: !isNotNullOrEmpty(savedFilters?.selected),
      options: savedFilters?.options,
      valueRenderer: null,
      valueRenderer: null,
      itemRenderer: (item) => (
        <>
          <div
            className="SavedFilterOption"
            onClick={(e) => handleSavedFilterItemSelectClick(e, item)}
            key={item?.filterId}
          >
            <span>{item?.filterName}</span>
            <div className="SaveFilterOtionHover">
              <button
                style={{ background: "transparent" }}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(filterActions.setSavedFilterSelected(item));
                  dispatch(modalActions.showSavedFilterDeleteModal(true));
                }}
              >
                <img src={DeleteIcon} />
              </button>
              <button
                style={{ background: "transparent" }}
                onClick={(e) => {
                  e.stopPropagation();
                  //   dispatch(cameraActions.toggleInfoFilterModal(true));
                  infoDataGet(item);
                  //   dispatch(cameraActions.setFilterInfoName(item.filterName));
                }}
              >
                <img src={InfoIcon1} />
              </button>
            </div>
          </div>
        </>
      ),
    },
    filterList: [
      {
        labelledBy: CUSTOMER,
        options: customer?.options,
        value: customer?.selected,
        // onChange: (value) => setSelected(value),
        onChange: (value) => handleFilterItemChange(value, CUSTOMER),
        valueRenderer: null,
        className:
          customer?.selected.length > 0
            ? "dropdownSelectionContainer multi-select"
            : "multi-select",
      },
      {
        labelledBy: SITE,
        options: site?.options,
        value: site?.selected,
        onChange: (value) => handleFilterItemChange(value, SITE),
        valueRenderer: null,
        //disabled: customer?.selected?.length === 0
        className:
          site?.selected.length > 0
            ? "dropdownSelectionContainer multi-select"
            : "multi-select",
      },
      {
        labelledBy: INTERFACESUBTYPE,
        options: interfaceSubType?.options,
        value: interfaceSubType?.selected,
        onChange: (value) => handleFilterItemChange(value, INTERFACESUBTYPE),
        valueRenderer: null,
        //disabled: site?.selected?.length === 0
        className:
          interfaceSubType?.selected.length > 0
            ? "dropdownSelectionContainer multi-select"
            : "multi-select",
      },
      {
        labelledBy: INTERFACE,
        options: deviceInterface?.options,
        value: deviceInterface?.selected,
        onChange: (value) => handleFilterItemChange(value, INTERFACE),
        valueRenderer: null,
        //disabled: interfaceSubType?.selected?.length === 0
        className:
          deviceInterface?.selected.length > 0
            ? "dropdownSelectionContainer multi-select"
            : "multi-select",
      },
    ],
  };

  const handleSingleViewClick = () => {};

  const handleViewMosaicClick = () => {};

  const infoDataGet = (item) => {
    getInfoList(item?.filterId)
      .then((res) => {
        if (res.Status == "success") {
          //let temp = JSON.parse(res.Data);
          //   infoDataFilter(res.Data);
        } else {
        }
      })
      .catch((err) => console.log(err));
  };

  const isAtLeastOneDeviceChecked = () => {
    return devicesList?.filter((item) => item?.isChecked)?.length > 0;
  };

  // get comma seperated Ids
  const getCSIds = (selectedData) => {
    if (selectedData?.length > 0) {
      let clientIds = selectedData?.map((item) => item.value)?.join(",");
      return clientIds;
    } else {
      return null;
    }
  };

  // get comma seperated devices Ids
  const getCSDeviceIds = () => {
    if (devicesList?.length > 0) {
      let deviceIds = devicesList
        ?.filter((item) => item?.isChecked)
        ?.map((i) => i.DeviceId)
        ?.join(",");
      return deviceIds;
    } else {
      return null;
    }
  };

  // Handle when filter button is clicked
  const handleFilterClick = () => {
    let clientIds = getCSIds(customer?.selected);
    let siteIds = getCSIds(site?.selected);
    let interfaceSubtTypeIds = getCSIds(interfaceSubType?.selected);
    let interfaceIds = getCSIds(deviceInterface?.selected);
    let devicesIds = ""; //getCSDeviceIds();
    let deviceType = "Camera";
    dispatch(
      fetchRecordingDevicesList(
        clientIds ?? "",
        siteIds ?? "",
        interfaceSubtTypeIds ?? "",
        interfaceIds ?? "",
        devicesIds,
        false,
        deviceType ?? ""
      )
    );
    dispatch(recordingActions.setDevicesListSearchText(""));
    dispatch(recordingActions.resetCameraPlaybackList());
  };

  const handleClearFilterClick = () => {
    // dispatch(filterActions.resetSavedFilter());
    dispatch(filterActions.resetCustomer());
    dispatch(filterActions.resetSite());
    dispatch(filterActions.resetInterfaceSubType());
    dispatch(filterActions.resetInterface());
    dispatch(recordingActions.resetDevicesList());
    dispatch(recordingActions.resetCameraDetails());
    dispatch(buttonActions.resetAllButtons());
    dispatch(recordingActions.resetCameraPlaybackList());
    dispatch(recordingActions.setDevicesListSearchText(""));
  };

  const handleSaveFilterModalClick = () => {
    let clientIds = getCSIds(customer?.selected);
    let siteIds = getCSIds(site?.selected);
    let interfaceSubtTypeIds = getCSIds(interfaceSubType?.selected);
    let interfaceIds = getCSIds(deviceInterface?.selected);
    let deviceIds = getCSDeviceIds();
    let filterText = `clientIds:${clientIds ?? ""};siteIds:${
      siteIds ?? ""
    };interfaceSubTypeIds:${interfaceSubtTypeIds ?? ""};interfaceIds:${
      interfaceIds ?? ""
    };deviceIds:${deviceIds ?? ""}`;
    if (filterName == "") {
      ErrorToast("Kindly enter a filter name");
      return;
    }
    dispatch(savedFilters(filterName, RECORDING, filterText));
    dispatch(modalActions.showSavedFilterSaveModal(false));
    dispatch(filterActions.resetFilterName());
  };

  const handleDevicesListItemClick = (e, listItem) => {
    // if (isSyncReplayMode()) return;
    // dispatch(fetchRecordingCameraDetailsById(listItem?.DeviceId));
    // setStartMode(true)
  };

  const handleSyncReplayClick = () => {};

  const handleClearSyncReplayClick = () => {
    if (isNotNullOrEmpty(savedFilters?.selected)) {
      let lst = devicesList?.map(({ isChecked, ...rest }) => {
        let item = null;
        if (isChecked !== undefined || isChecked !== null) {
          item = { ...rest };
        } else {
          item = { ...rest };
        }

        return item;
      });
      dispatch(recordingActions.setDevicesList(lst));
    } else {
      let lst = devicesList?.map(({ isChecked, ...rest }) => {
        return { isChecked: false, ...rest };
      })
      dispatch(recordingActions.setDevicesList(lst));
    }
    dispatch(buttonActions.disableClearSyncReplayBtn(true))
    dispatch(recordingActions.showMultiPlaybackView(false))
    dispatch(recordingActions.resetCameraPlaybackList());
  };

  const validatePlayBackDatePickerVisibility = () => {
    return (
      devicesList?.filter(
        (item) => item?.hasOwnProperty("isChecked") && item?.isChecked && item
      ).length < 1 ||
      devicesList?.filter(
        (item) => item?.hasOwnProperty("isChecked") && item?.isChecked && item
      ).length > 4
    );
  };

  const handleSavedFilterItemSelectClick = (e, item) => {
    dispatch(filterActions.setSavedFilterSelected(item));
    dispatch(filterActions.resetCustomer());
    dispatch(recordingActions.resetCameraDetails());
    dispatch(recordingActions.resetCameraPlaybackList());

    let filterData = parseSCSEntitiesToObect(item?.filterValues);
    if (isNotNullOrEmpty(filterData)) {
      let clientIds = filterData?.Client;
      let siteIds = filterData?.Site;
      let interfaceSubTypeIds = filterData?.Interfacesubtype;
      let interfaceIds = filterData?.Interface;
      let devicesIds = filterData?.Device;
      let deviceType = "Camera";

      dispatch(
        fetchRecordingDevicesList(
          clientIds ?? "",
          siteIds ?? "",
          interfaceSubTypeIds ?? "",
          interfaceIds ?? "",
          devicesIds ?? "",
          true,
          deviceType ?? ""
        )
      );
    }
  };

  //Check if sync replay mode is enabled
  const isSyncReplayMode = () => {
    return visibleSyncReplayBtn && !visibleClearSyncReplayBtn;
  };

  const shouldFilterAndClearFilterBtnsBeEnabled = () => {
    let isEnabled = false;
    if (isNotNullOrEmpty(savedFilters?.selected)) {
      isEnabled = false;
    }

    if (isNotNullOrEmpty(customer?.selected)) {
      isEnabled = true;
    }
    return isEnabled;
  };

  const isSaveFilterBtnEnabled = () => {
    let isEnabled = false;
    if (isNotNullOrEmpty(savedFilters?.selected)) {
      isEnabled = false;
    } else if (isNotNullOrEmpty(customer?.selected)) {
      if (isNotNullOrEmpty(devicesList) && isAtLeastOneDeviceChecked()) {
        isEnabled = true;
      }
    } else {
      isEnabled = false;
    }
    return isEnabled;
  };

  const isViewMosaicBtnEnabled = () => {};

  const handleDevicesListCheckBoxChange = async (e, device) => {
    let { checked } = e.target;
const checkedCount = devicesList.filter((item) => item?.isChecked).length;

  if (checked && checkedCount >= 4) {
    WarningToast("Maximum 4 cameras can be selected");
    return;
  }
    //  false = button is enabled
    if (true) {
      let lst = [];
      let tempDeviceList = [...devicesList];
      if (
        tempDeviceList.filter((item) => item?.isChecked).length === 1 &&
        !checked
      ) {
        lst = [
          ...tempDeviceList.map((item) => {
            return { ...item, isChecked: false };
          }),
        ];
      } else {
        lst = [
          ...tempDeviceList?.map(({ isChecked, ...rest }) => {
            let item = null;
            if (rest?.Abbreviation === device?.Abbreviation) {
              item =
                rest?.DeviceId === device?.DeviceId
                  ? { isChecked: checked, ...rest }
                  : { isChecked, ...rest };
            } else {
              item = { ...rest };
            }
            return item;
          }),
        ];
      }

      //Logic for getting playback data in sync replay mode
      let playbackList = [...cameraPlaybackList];

      if (
        checked &&
        playbackList.find(
          (item) => item?.ParentCameraID === device?.DeviceId
        ) === undefined
      ) {
        let cameraObj = await fetchCameraDetailsByIdWD(device?.DeviceId);

        if (isNotNullOrEmpty(cameraObj)) {
          playbackList.push(cameraObj);
          dispatch(recordingActions.setCameraPlaybackList(playbackList));
        }
      } else {
        let lst = [
          ...playbackList?.filter(
            (item) => item?.ParentCameraID !== device?.DeviceId && item
          ),
        ];
        dispatch(recordingActions.setCameraPlaybackList(lst));
      }

      dispatch(recordingActions.setDevicesList(lst));
      dispatch(recordingActions.showMultiPlaybackView(false));
    } else {
      const list = devicesList?.map((item) => {
        return item?.DeviceId === device?.DeviceId
          ? { ...item, isChecked: checked }
          : item;
      });
      dispatch(recordingActions.setDevicesList(list));
    }
  };

  //playback function

  const handlePlaybackClick = (listItem) => {
    setLoading(true);
    setPopOpen(false);
    if (new Date(startDate) >= new Date(endDate)) {
      ErrorToast("Start time should be earlier than end time!");
      setLoading(false);
      return;
    }

    let startDateStr = formatJSDateObject(startDate);
    let endDateStr = formatJSDateObject(endDate);

    let playbackUrl = [];
    for (let i = 0; i < cameraPlaybackList?.length; i++) {
      let obj = {
        // startTime: startDateStr.replace(/[ :-]/g, "_"),
        // endTime: endDateStr.replace(/[ :-]/g, "_"),
        startTime: formatJSDateInDDMMYYYY(startDateStr),
        endTime: formatJSDateInDDMMYYYY(endDateStr),
        deviceId: cameraPlaybackList[i]?.ParentCameraID.toString(),
      };

      playbackUrl.push(obj);
    }

    let tempPlaybackList = [...cameraPlaybackList];

    Promise.all(
      playbackUrl.map((item) => fetchRecordingCameraDetailsById(item))
    )
      .then((res) => {
        let lst = [
          ...tempPlaybackList.map((item, index) => {
            return { ...item, playbackURL: res[index]?.Data };
          }),
        ];

        dispatch(recordingActions.setCameraPlaybackList(lst));
        setPopOpen(false);
        dispatch(recordingActions.showMultiPlaybackView(true));
        dispatch(buttonActions.disableClearSyncReplayBtn(false));
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Error while fetching stream url => ", err);
      });
    
    dispatch(playbackActions.setSelectedStartDate(startDate));
    dispatch(playbackActions.setSelectedEndDate(endDate));

    dispatch(playbackActions.setStartDate(""));
    dispatch(playbackActions.setEndDate(""));
    dispatch(playbackActions.setTimerInputTimeString(""));
  };

  const handleDeviceListSearchChange = (e) => {
    let { value } = e.target;
    dispatch(recordingActions.setDevicesListSearchText(value));
  };

  const CLIENT = "Client";
  const SITEINFO = "Site";
  const INTERFACESUBTYPEINFO = "Interface sub type";
  const INTERFACENAME = "Interface";

  const searchHandler = (e, type) => {
    if (type == CLIENT) {
      dispatch(recordingActions?.setCustomerSearch(e.target.value));
      // let tempCustomer = customerInfo
    }
  };

  return (
    <div className="MainContentMargin">
      <div
        className="row col-lg-12"
        style={{ margin: "0 auto", padding: "0px" }}
      >
        <div className="col-lg-12 dashboardHeadingInnerDiv">
          <div className="NameHeading1">
            <p>Video Backup</p>
          </div>
        </div>
      </div>
      <div className="col-lg-12 mt-2 mb-2">
        <div className="SiteMainContainer">
          <div
            className="soundContainer cameraFilterPage"
            style={{ padding: "10px" }}
          >
            <div className="FilteredCameraListDiv">
              <FilterToolDDL {...filterToolDDLProps} />
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Apply Filter</Tooltip>}
              >
                <button
                  className={`${
                    visibleFilterBtn ? "buttonDisable" : "IconsButtonDiv"
                  }`}
                  name="filterBtn"
                  disabled={visibleFilterBtn}
                  onClick={handleFilterClick}
                >
                  <img
                    src={FilterIcon}
                    className="camera-icon-height"
                    alt="Save filter icon"
                  />
                </button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Clear Filter</Tooltip>}
              >
                <button
                  className={`${
                    visibleClearFilterBtn ? "buttonDisable" : "IconsButtonDiv"
                  }`}
                  name="clearFilterBtn"
                  disabled={visibleClearFilterBtn}
                  onClick={handleClearFilterClick}
                >
                  <img
                    src={ClearFilter}
                    className="camera-icon-height"
                    alt="Save filter icon"
                  />
                </button>
              </OverlayTrigger>
              {/* <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Save Filter</Tooltip>}
              >
                <button
                  className={`${
                    visibleSaveFilterBtn ? "buttonDisable" : "IconsButtonDiv"
                  }`}
                  name="saveFilterBtn"
                  disabled={visibleSaveFilterBtn}
                  onClick={() =>
                    dispatch(modalActions.showSavedFilterSaveModal(true))
                  }
                >
                  <img
                    src={SaveFilter}
                    className="camera-icon-height"
                    alt="Save filter icon"
                  />
                </button>
              </OverlayTrigger> */}
              {/* {!visibleSyncReplayBtn && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Sync Replay</Tooltip>}
                >
                  {isMultiPlay == false && (
                    <button
                      className={`${
                        false ? "buttonDisable" : "IconsButtonDiv"
                      }`}
                      name="syncReplayBtn"
                      onClick={handleSyncReplayClick}
                      disabled={visibleSyncReplayBtn}
                    >
                      <img
                        src={RecordingReply}
                        className="camera-icon-height"
                        alt="Sync reply icon"
                      />
                    </button>
                  )}
                </OverlayTrigger>
              )} */}
              {true && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Clear Sync Replay</Tooltip>}
                >
                  {isMultiPlay == false && (
                    <button
                      className={`${
                        visibleClearSyncReplayBtn ? "buttonDisable" : "IconsButtonDiv"
                      }`}
                      name="clearSyncReplayBtn"
                      onClick={handleClearSyncReplayClick}
                      disabled={visibleClearSyncReplayBtn}
                    >
                      <img
                        src={CancelSyncReply}
                        className="camera-icon-height"
                        alt="Sync reply icon"
                      />
                    </button>
                  )}
                </OverlayTrigger>
              )}
              {/* <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>View Single</Tooltip>}
              >
                <button
                  className={`${
                    visibleSingleViewBtn ? "buttonDisable" : "IconsButtonDiv"
                  }`}
                  name="viewMosaicBtn"
                  disabled={visibleSingleViewBtn}
                  // disabled={!isNotNullOrEmpty(savedFilters.selected) && isNotNullOrEmpty(devicesList)}
                  onClick={handleSingleViewClick}
                >
                  <img
                    src={SingleRecording}
                    className="camera-icon-height"
                    alt="Alert filter icon"
                  />
                </button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>View Mosaic</Tooltip>}
              >
                <button
                  className={`${
                    visibleViewMosaicBtn ? "buttonDisable" : "IconsButtonDiv"
                  }`}
                  name="viewMosaicBtn"
                  disabled={visibleViewMosaicBtn}
                  // disabled={!isNotNullOrEmpty(savedFilters.selected) && isNotNullOrEmpty(devicesList)}
                  onClick={handleViewMosaicClick}
                >
                  <img
                    src={ViewMosaic}
                    className="camera-icon-height"
                    alt="Alert filter icon"
                  />
                </button>
              </OverlayTrigger> */}
            </div>
            <div className="ListFilterCamera">
              {devicesList?.length === 0 ? (
                <>
                  <div style={{ width: "100%" }}>
                    <AlertTemplateMessage
                      message={
                        "Use the filters above to customize your view"
                      }
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="CameraLeftContainer mr-3">
                    {devicesList?.some((item) =>
                      item?.hasOwnProperty("isChecked")
                    ) && (
                      <div className="selectCountClearSelection">
                        <div>
                          <p className="ListofText">
                            {
                              devicesList?.filter((item) => item?.isChecked)
                                ?.length
                            }{" "}
                            <span className="SiteNameText"> Selected of</span>{" "}
                            {devicesList?.length}
                          </p>
                        </div>
                        {/* {!isSyncReplayMode() && (
                          <div
                            className="clearSelection"
                            // onClick={handleSelectionClick}
                          >
                            {true ? CLEARSELECTION : SELECTALL}
                          </div>
                        )} */}
                      </div>
                    )}
                    <RecordingList
                      data={devicesList}
                      handleCheckBoxChange={handleDevicesListCheckBoxChange}
                      handleListSearchChange={handleDeviceListSearchChange}
                      handleListItemClick={handleDevicesListItemClick}
                      listSearchText={deviceListSearchText}
                    />
                  </div>

                  <div className="CameraRightContainer">
                    {visibleClearSyncReplayBtn &&
                      validatePlayBackDatePickerVisibility() &&
                      // !isNotNullOrEmpty(savedFilters?.selected) &&
                      // devicesList?.filter((item) => item?.isChecked)?.length ===
                      //   0 &&
                      cameraDetails === null && (
                        <>
                          <div
                            style={{
                              padding: "0px 20px",
                              display: "block",
                              marginBottom: "10px",
                            }}
                          >
                            <AlertTemplateMessage
                              message={
                                // "Check one or more cameras from the list to save as a filter."
                                "Select 1 or max 4 camera from the list to view playback"
                              }
                            />
                          </div>
                        </>
                      )}

                    {!validatePlayBackDatePickerVisibility() &&
                      // isNotNullOrEmpty(
                      //   cameraPlaybackList?.filter(
                      //     (item) => !isNotNullOrEmpty(item?.playbackURL)
                      //   )
                      // ) && 
                      (
                        <>
                          <div
                            className="playback__datepickers"
                            // style={{ boxShadow: "none", display: "block" }}
                          >
                            <div className="singleInputDiv">
                              <span>
                                {selectedStartDate
                                  ? formatJSDateInDDMMYYYY(selectedStartDate)
                                  : "Select date and time"}
                              </span>
                              <img
                                src={calendar}
                                onClick={() => setPopOpen(true)}
                              />
                            </div>
                            {selectedEndDate && (
                              <>
                                <img
                                  className="mx-3"
                                  src={DateTimeArrow}
                                  alt="DateTimeArrow"
                                />
                                <p
                                  className="mx-3"
                                  id="endDateStringSinglePlayback"
                                >
                                  {/* {frontDateConverter(endDateString)} */}
                                  {/* {ConvertDate(dateTwo)} */}
                                  {formatJSDateInDDMMYYYY(selectedEndDate)}
                                </p>
                              </>
                            )}
                            {/* <form className="singleInputDiv">
                                                <input
                                                    // value={frontDateConverter(startDateString)}
                                                    value={frontDateConverter(new Date().toISOString())}
                                                    className="singleInput"
                                                />
                                                <img src={calendar} onClick={() => setPopOpen(true)} />
                                                </form> */}
                          </div>
                        </>
                      )}

                    {/* {
                      !isSyncReplayMode() &&
                      isNotNullOrEmpty(cameraDetails) && (
                        <>
                          <div className="MainContainerSectionCamera">
                            <div className="cameraDetailDiv">
                              {
                                !cameraDetails ? (
                                  <SkelSinglePlayback></SkelSinglePlayback>
                                ) : (
                                  <div style={{height: "100%"}}>
                                    <RecordingVideo playbackList={cameraPlaybackList} />
                                  </div>
                                )
                              }
                            </div>
                          </div>
                        </>
                      )
                    } */}

                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          minHeight: "40vh",
                          width: "100%",
                        }}
                      >
                        <CircularProgress />
                        <div
                          style={{
                            marginTop: "1rem",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Loading playback video, please wait...
                        </div>
                      </div>
                    ) : (
                      visibleMultiPlaybackView && (
                        <MultiplaybackView
                          visibleMultiPlaybackView={visibleMultiPlaybackView}
                          isCR={true}
                          playbackList={cameraPlaybackList}
                        />
                      )
                    )}

                    

                    {/* {!isSyncReplayMode() && (
                      <>
                        <div className="MainContainerSectionRecording">
                          <>
                            {!true ? (
                                                <SkelSinglePlayback></SkelSinglePlayback>
                                                ) : (
                                                // <WebRTCPlayer
                                                //     key={775}
                                                //     id={775}
                                                //     url={"rtsp://admin:2o2oImaging@192.168.0.64:554/cam/realmonitor?channel=3&subtype=1"}
                                                //     // isEncode={cameraDetails.isTranscoded}
                                                //     // item={cameraDetails}
                                                //     upperDivCss="singleCameraHover"
                                                //     videoCss="mosaic"
                                                //     fullVideoCss="player-responsive-fullScreen"
                                                //     buttonCss="mosaicButtonsMainDiv"
                                                //     noStreamDivCss="singleplaybackNoStream"
                                                //     playback={true}
                                                //     showPlaybackBtn={true}
                                                //     // prePostDisplay={false}
                                                //     liveButton={true}
                                                //     setStartDateString={setStartDateString}
                                                //     setEndDateString={setEndDateString}
                                                //     setStartMode={setStartMode}
                                                //     showHooterIcon={startMode ? true : false}
                                                //     showAlertCreation={startMode ? true : false}
                                                // />
                                                )}
                          </>
                        </div>
                        
                        <SeekBar />
                      </>
                    )} */}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

       
          

      {/* Modal for Playback */}
      <Modal
        show={popOpen}
        onHide={() => {
          setPopOpen(false);
          dispatch(playbackActions.setStartDate(""));
          dispatch(playbackActions.setEndDate(""));
          dispatch(playbackActions.setTimerInputTimeString(""));
          dispatch(playbackActions.resetPlaybackState());
        }}
        className="singleplaybackexportModal"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className="ModelHeaderName">Playback</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Playback
            selectedMoreThanOne={devicesList.filter((item) => item?.isChecked).length > 1}
            handlePlaybackClick={handlePlaybackClick}
            selectedDeviceTimeZoneOffsetMinutes={
              cameraPlaybackList[0]?.OffsetMinutes
            }
            deviceId={cameraPlaybackList[0]?.ParentCameraID}
          />
        </Modal.Body>
      </Modal>

      {/* Modal popup for save filter */}
      <Modal
        size="lg"
        show={showSavedFilterSaveModal}
        onHide={() => dispatch(modalActions.showSavedFilterSaveModal(false))}
        dialogClassName="modal-90w"
        backdrop="static"
        className="saveCameraFilterModal"
      >
        <>
          <Modal.Header>
            <Modal.Title id="example-custom-modal-styling-title">
              Save Filter
            </Modal.Title>
            <img
              src={RemoveIcon}
              alt="Remove"
              style={{ cursor: "pointer" }}
              onClick={() =>
                dispatch(modalActions.showSavedFilterSaveModal(false))
              }
            />
          </Modal.Header>

          <Modal.Body>
            <div className="inputMainContainer w40dot75rem w-100">
              <div className="inputTypeLabelContainer">
                <label className="formFieldLabels">Filter Name</label>
                <input
                  style={{ width: "40vw" }}
                  type="text"
                  className="inputType"
                  value={filterName}
                  placeholder="Ex. Filter for xyz company with 10 sites"
                  // {...register("AddCustomerName")}
                  // onChange={handleFilterNameInputChange}
                />
                <p className="Error_P" style={{ float: "left" }}>
                  <span>{}</span>
                </p>
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <button
                //disabled={filterName === ""}
                className="DataAccessEdit mt-3"
                style={{ width: "250px" }}
                onClick={handleSaveFilterModalClick}
              >
                <span className="ViewUpdate">Save</span>
              </button>
            </div>
          </Modal.Body>
        </>
      </Modal>
    </div>
  );
});
